module.exports = __webpack_public_path__ + "media/character-grandpa-sad.40138346.mp3";